import { z } from "zod";
import { deviceSubmissionResponseBodySchema } from "./deviceSubmissionResponseBodySchema";

export const deviceSubmissionResponseSpecSchema = z.object({
  responseCode: z.enum(["auto", "200", "400", "404", "500"]),
  response: deviceSubmissionResponseBodySchema,
});

export type DeviceSubmissionResponseSpec = z.infer<
  typeof deviceSubmissionResponseSpecSchema
>;
